export default __webpack_public_path__ + "static/media/my-home-a.47fca363.svg";